<template>
  <div class="" style="position:fixed">
      <b-container fluid style="padding-top: 100px; ">
        <b-row>
          <b-col cols="12 headerF"><HeaderFixed/></b-col>
          <b-col cols="12 headerM"><HeaderMobile/></b-col>
        </b-row>
        <b-row>
          <b-col cols="12">
              <b-breadcrumb style=" background-color: #e9ecef78;">

                  <b-breadcrumb-item href="#home">
                    <router-link to="/Assamese">
                        <b-icon icon="house-door" scale="1.25" shift-v="1.25" aria-hidden="true"></b-icon>
                        মূখ্যপৃষ্ঠা
                    </router-link>
                  </b-breadcrumb-item>
                  <b-breadcrumb-item href="#home">
                    <router-link to="/AS_AllDocuments">
                      নথি
                    </router-link>
                  </b-breadcrumb-item>

                 <b-breadcrumb-item href="#" active>কোম্পানীৰ বাৰ্ষিক ৰিটাৰ্ণ</b-breadcrumb-item>
              </b-breadcrumb>
            </b-col>
        </b-row>

        <b-row>
          <b-col cols="12" style="height:75vh; overflow-y:scroll;width:99vw">
            <div class="cntnt">

          <div id="Fin1">
            <b-row>
              <b-col cols="6">
                  <h1 class="heading">কোম্পানীৰ বাৰ্ষিক ৰিটাৰ্ণ</h1>
              </b-col>

           </b-row>
           <p class="content">
              <b-table :items="getAnnualReturn" :fields="AnnualReturnfields">
                <template v-slot:cell(name)="data">
                 <span   v-html="data.value"></span>
                </template>
                <template v-slot:cell(date)="data">
                  <span   v-html="data.value"></span>
                </template>
              </b-table>
            </p>
          </div>

          </div>
          </b-col>
        </b-row>
      </b-container>
      <br><br>
  </div>
</template>



<script>

import HeaderFixed from '@/components/AS_HeaderFixed.vue'
import HeaderMobile from '@/components/AS_HeaderMobile.vue'
import { mapGetters, mapActions } from 'vuex'
export default {

  components: {
      'HeaderFixed' : HeaderFixed,
      'HeaderMobile' : HeaderMobile
    },
  data() {
      return {
        AnnualReturnfields: [
          { key: 'name', label: 'Particulars',thStyle: {width: '80vw'} },
          // { key: 'date', label: 'Dated',thStyle: {width: '10vw'} }
        ]
      }

  },
  computed:
  {
    ...mapGetters([
      'getAnnualReturn'
    ])
  },
  methods: {
    ...mapActions([
      'retrieveAnnualReturn'
    ])
  },
  beforeMount() {
      if(this.getAnnualReturn.length == 0) {
        this.retrieveAnnualReturn()
      }
  }
}
</script>

<style scoped="true">
li{
  padding:0;
}

    body{
      overflow-y:hidden;
    }
.heading {
  border-left: 10px solid #ed7c27;
  border-left-width: 10px;
  border-left-style: solid;
  border-left-color: rgb(237, 124, 39);
  font-size: 25px;
  text-align: left;
  letter-spacing: 1px;
  padding-left: 1rem;
  margin-bottom: 2rem;
  margin-top: 1rem;
  text-transform: capitalize;

}
.content{
    text-align: justify;
line-height: 1.5rem;
font-size:0.9rem;
}
.cntnt{
box-shadow: 0 -2px 15px 0 rgba(0, 0, 0, 0.2), 0 10px 10px 0 rgba(0, 0, 0, 0.19);
padding:10px 30px 10px 30px;


}

table{
  text-align: left !important;
}
.headerF{
  display: block;
}
.headerM{
  display: none;
}

@media (max-width: 768px) {
    .headerF{
      display: none;
    }
    .headerM{
      display: block;
    }
  }

</style>
